export default "__VITE_ASSET__D0xE$GVe__"